import { render, staticRenderFns } from "./WhereToBuy.vue?vue&type=template&id=43e44950&scoped=true"
import script from "./WhereToBuy.vue?vue&type=script&lang=js"
export * from "./WhereToBuy.vue?vue&type=script&lang=js"
import style0 from "./WhereToBuy.vue?vue&type=style&index=0&id=43e44950&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e44950",
  null
  
)

export default component.exports